import { useJazyk } from '../../context/LanguageContext';
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { MessageCircle, Flag } from 'lucide-react';
import { API } from '../../lib/api';
import { useNavigate } from 'react-router-dom';

export function UserRatings({ userId, username }) {
  const { t } = useJazyk();
  const navigate = useNavigate();
  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [reportReason, setReportReason] = useState('');
  const [reportDescription, setReportDescription] = useState('');
  const [reportLoading, setReportLoading] = useState(false);

  const handleSendMessage = () => navigate('/messages', { state: { startChatWith: userId } });

  const handleReportUser = async (e) => {
    e.preventDefault();
    if (!reportReason) { toast.error(t('cp.vyberteDuvodChyba')); return; }
    setReportLoading(true);
    try {
      await axios.post(`${API}/users/${userId}/report`, { reason: reportReason, description: reportDescription });
      toast.success(t('cp.nahlaseniOdeslano'));
      setReportDialogOpen(false);
      setReportReason(''); setReportDescription('');
    } catch (err) {
      toast.error(err.response?.data?.detail || t('cp.chybaNahlaseni'));
    } finally {
      setReportLoading(false);
    }
  };

  return (
    <div className="space-y-2 mt-2">
      <Button onClick={handleSendMessage} className="w-full bg-bloom-violet text-white text-sm" data-testid="send-message-btn">
        <MessageCircle className="w-4 h-4 mr-1.5" />{t('cp.napsatZpravu')}
      </Button>

      <Dialog open={reportDialogOpen} onOpenChange={setReportDialogOpen}>
        <DialogTrigger asChild>
          <button className="w-full text-xs text-bloom-sub/60 hover:text-destructive/70 flex items-center justify-center gap-1 py-1 transition-colors" data-testid="report-user-btn">
            <Flag className="w-3 h-3" />{t('cp.nahlasitUzivatele')}
          </button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="font-serif text-bloom-text">{t('cp.nahlasitKoho', { kdo: username })}</DialogTitle>
            <DialogDescription>{t('cp.popisteDuvod')}</DialogDescription>
          </DialogHeader>
          <form onSubmit={handleReportUser} className="space-y-4">
            <div className="h-1 bg-gradient-to-r from-[#5BCEFA] via-[#F5A9B8] to-[#5BCEFA] rounded" />
            <p className="text-xs text-bloom-sub">{t('cp.zustaneteAnonymni')}</p>
            <div className="space-y-1.5">
              <p className="text-sm text-bloom-text font-medium">{t('cp.duvodP')}</p>
              <Select value={reportReason} onValueChange={setReportReason}>
                <SelectTrigger data-testid="report-reason-select"><SelectValue placeholder={t('cp.vybertDuvod')} /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="spam">Spam nebo reklama</SelectItem>
                  <SelectItem value="nevhodne-chovani">{t('cp.nevhodneChovani')}</SelectItem>
                  <SelectItem value="podvod">Podvod</SelectItem>
                  <SelectItem value="falesny-profil">{t('cp.falesnyProfil')}</SelectItem>
                  <SelectItem value="jiny">{t('cp.jinyProblem')}</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5">
              <p className="text-sm text-bloom-text">{t('cp.popisVolitelny')} <span className="text-bloom-sub text-xs">{t('cp.volitelny')}</span></p>
              <Textarea value={reportDescription} onChange={e => setReportDescription(e.target.value)} placeholder={t('cp.popisteSituaci')} rows={3} data-testid="report-description-input" />
            </div>
            <Button type="submit" className="w-full bg-destructive/90 text-white hover:bg-destructive" disabled={reportLoading} data-testid="submit-report-btn">
              {t(reportLoading ? 'ram.odesilam' : 'cp.odeslatNahlaseni')}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
